import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["color", "fontSize", "className", "style"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Icon as MuiIcon } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
/** Overrides the Material UI Icon Component so we can add custom RaiseColors and font sizes */
var Icon = function Icon(_ref) {
  var color = _ref.color,
    fontSize = _ref.fontSize,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    muiIconProps = _objectWithoutProperties(_ref, _excluded);
  if (fontSize === "xsmall") {
    fontSize = 14;
  }
  if (fontSize === "small") {
    fontSize = 16;
  }
  if (fontSize === "medium") {
    fontSize = 20;
  }
  if (fontSize === "default") {
    fontSize = 24;
  }
  if (fontSize === "large") {
    fontSize = 28;
  }
  if (fontSize === "xlarge") {
    fontSize = 40;
  }
  return /*#__PURE__*/_jsx(MuiIcon, _objectSpread({
    className: className,
    style: _objectSpread({
      color: color,
      fontSize: fontSize,
      width: "initial",
      height: "initial"
    }, style)
  }, muiIconProps));
};
export default Icon;